import { ArticleContactViewModel } from './ArticleContactViewModel';
import { ArticleStatusEnum } from '../enums/ArticleStatus.enum';
import { BodyContentsModel } from './BodyContentsModel';
import { TimeModel } from '../../../Common/Forms/models/time.model';
import { deliverySchedulingTypesEnum } from '../../../Common/Forms/enums/delivery-scheduling-types.enum';
import { DistributionRegionsEnum } from '../enums/DistributionRegions.enum';

export class ArticleViewModel {
    articleId: number;
    articleName: string;
    headline: string = '';
    body: string;
    author: string;
    publishedDate: number;
    imageData: string;
    aboutUs: string;
    articleStatus: ArticleStatusEnum  ;
    links: string[] = [];
    companyName: string = '';
    contacts: ArticleContactViewModel[] = [];
    previewUrl: string;
    reportUrl: string;

    createdDate: Date;
    lastModifiedDate: Date;
    createdByUserId: number;
    regions: DistributionRegionsEnum[];
    scheduledDate: Date;
    scheduledTime: TimeModel;
    schedulingType: deliverySchedulingTypesEnum;
    industryId?: number;
    metaData: string;
    contactName: string;
    contactPhone: string;
    contactEmail: string;
    preferredMethodId?: number;
    notesForEditor: string;

    timeZone: string;
    lastNotificationHeadline: string;
    lastNotificationBody: string;
    lastNotificationDate: Date;
    lastNotificationStatus: string;
    accountId: number;
    accountName: string;
    companyLogo: string;

    bodyContents: BodyContentsModel[] = [];
    datelineLocation: string = '';
    datelineDate: Date;
}
